var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconClassroomJoinedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .member-cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.1px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "member-cls-1",
    points: "30.2 37.5 33.4 40.6 38.6 32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "member-cls-1",
    d: "M25.8,28c.5-.5,1-.9,1.7-1.2-1.4-.5-2.8-.8-4.4-.8h-4.9c-7.1,0-12.9,5.8-12.9,12.9v5.8c0,1.2,1,2.3,2.3,2.3h18.5s-2.1-2.2-2.1-4.2v-10.4c0-1.7.7-3.2,1.8-4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "member-cls-1",
    cx: 20.6,
    cy: 14.4,
    r: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "member-cls-1",
    x: 24,
    y: 26.6,
    width: 20.8,
    height: 20.8,
    rx: 5.2,
    ry: 5.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconClassroomJoinedLine);
export default __webpack_public_path__ + "static/media/cloud_icon_classroom_joined_line_.fccd8aec81b7993287f5f8d5f667cfe6.svg";
export { ForwardRef as ReactComponent };